// extracted by mini-css-extract-plugin
export default {"orderManageFormHeader":"OrderManageFromHeader_orderManageFormHeader__vaor8","title":"OrderManageFromHeader_title__cKyfT"};